export const Constants = {
  bannerSlider:[
    {
      id:'1',
      title:'AI Meets Motorcycling: Join TGB',
    }
  ]
}